

export const situacaoCreditoOptions = {
    dataSource: [
      { id: 1, descricao: "EXIGIVEL" },
      { id: 2, descricao: "SUSPENSO" },
      { id: 3, descricao: "EXTINTO" },
    ],
    valueExpr: "id",
    displayExpr: "descricao",
  };

  export const situacaoInternaOptions = {
    dataSource: [
      { id: 0, descricao: "NENHUM" },
      { id: 1, descricao: "CDA CANCELADA" },
      { id: 2, descricao: "CDA GERADA" },
      { id: 3, descricao: "SEPARADA CANCELAMENTO" },
      { id: 4, descricao: "SEPARADA COBRANÇA" },
      { id: 5, descricao: "ENVIADA COBRANÇA" },
      { id: 6, descricao: "PROBLEMA COBRANÇA" },
      { id: 7, descricao: "EM COBRANÇA" },
    ],
    valueExpr: "id",
    displayExpr: "descricao",
  };

  export const tipoCobrancaOptions = {
    dataSource: [
      { id: 0, descricao: "NENHUM" },
      { id: 1, descricao: "PROTESTO" },
      { id: 2, descricao: "EXECUÇÃO FISCAL" },
    ],
    valueExpr: "id",
    displayExpr: "descricao",
  };
  
  export const tipoCancelamentoOptions = {
    dataSource: [
      { id: 0, descricao: "NÃO" },
      { id: 1, descricao: "CANCELAMENTO" },
      { id: 2, descricao: "PRESCRIÇÃO" },
      { id: 3, descricao: "REMISSÃO" },
      { id: 4, descricao: "EXCLUSÃO" },
      { id: 5, descricao: "ISENÇÃO" },
    ],
    valueExpr: "id",
    displayExpr: "descricao",
  };

  export const simNaoOptions = {
    dataSource: [
      { id: 0, descricao: " " },
      { id: 1, descricao: "SIM" },
      { id: 2, descricao: "NÃO" },
    ],
    valueExpr: "id",
    displayExpr: "descricao",
  };